import { MagnifyingGlass, X } from '@phosphor-icons/react';
interface SearchBarProps {
  type: string;
  search: string;
  setSearch: (value: string) => void;
}

const SearchBar = ({ type, search, setSearch }: SearchBarProps) => {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const clearSearch = () => setSearch('');
  return (
    <div className="flex w-full flex-row items-center gap-x-2 rounded-md border bg-white px-4 py-1">
      <MagnifyingGlass size={20} weight="bold" />
      <input
        data-testid="test-select-search-input"
        type="text"
        className="w-full border-gray-300 font-inter text-sm focus:outline-none"
        placeholder={`Search ${type}`}
        value={search}
        onChange={handleSearch}
      />
      <X
        weight="bold"
        className="cursor-pointer hover:text-brandRed-500"
        onClick={clearSearch}
      />
    </div>
  );
};

export default SearchBar;
